/**
 * Viewer roles on a race loaded from the public race endpoints.
 *
 * The backend no longer ships the role lists (raceAdmins, mediaWorkers, ...) to ordinary
 * viewers; a single race carries `viewerRoles` with six booleans computed server-side for
 * the logged-in user. Site admins and verified race admins still get the lists (they edit
 * them), so the list comparison stays as a fallback for responses that carry them.
 */

const ROLE_LISTS = {
    isRaceAdmin: 'raceAdmins',
    isMediaWorker: 'mediaWorkers',
    isTimeTracker: 'timeTrackers',
    isTdLeader: 'tdLeaders',
    isRaceLeader: 'raceLeaders',
    isTvRadioProducer: 'tvRadioProducers',
};

function cellphoneDigits(value) {
    return String(value || '').replace(/\D/g, '');
}

/**
 * True when the user holds `role` (e.g. 'isRaceAdmin') on the race.
 */
export function viewerHasRole(race, user, role) {
    if (!race || !ROLE_LISTS[role]) {
        return false;
    }
    if (race.viewerRoles && typeof race.viewerRoles === 'object') {
        return !!race.viewerRoles[role];
    }
    const digits = cellphoneDigits(user?.cellphone);
    const list = race[ROLE_LISTS[role]];
    if (!digits || !Array.isArray(list)) {
        return false;
    }
    return list.some(entry => entry && cellphoneDigits(entry.cellphone) === digits);
}

export function viewerIsRaceAdmin(race, user) {
    return viewerHasRole(race, user, 'isRaceAdmin');
}

/**
 * True when the loaded race object carries role information for this viewer at all
 * (used by routes that skip a reload when the race is already complete).
 */
export function hasViewerRoleData(race) {
    return !!race && (!!race.viewerRoles || Array.isArray(race.raceAdmins));
}
